export enum DocumentTypesForOrder {
  FILLED_FORM = "filled_form",
  APPROVAL_LETTER = "approval_letter",
  DENIAL_LETTER = "denial_letter",
  NAR_LETTER = "nar_letter",
  AUTH_LETTER = "auth_letter",
}

export enum ValidDocumentTypesForUpload {
  APPROVAL_LETTER = "approval_letter",
  DENIAL_LETTER = "denial_letter",
  NAR_LETTER = "nar_letter",
  AUTH_LETTER = "auth_letter",
}
